import { AxiosPromise } from 'axios';
import { instance } from '.';
import { URLS } from './index';
import { Logger } from 'fsts';
import { SearchParams } from '../model/searchParams';
import { DefaultBackendHelper } from '../utils/backendHelper';
import gspUserRole, { GspUserRole, Value } from '../model/gspUserRole';
import ODataFilterBuilder from 'odata-filter-builder';
import { CONST } from '@/shared/utils/Constants';

const logger = new Logger('backend.GspUserRole');
export interface BackendGspUserRole {
  getGspUserRole(id: string): AxiosPromise<GspUserRole>;
  getGspUserRoles: (searchParams: SearchParams) => AxiosPromise<Value>;
  deleteGspUserRole(id: string): AxiosPromise;
  updateGspUserRole(GspUserRole: GspUserRole): AxiosPromise<any>;
}

export const defaultBackendGspUserRole: BackendGspUserRole = {
  getGspUserRole(id: string): AxiosPromise<GspUserRole> {
    let url = `${URLS.gspUserRoleOdata}/${id}`;
    return instance.get<GspUserRole>(url);
  },
  getGspUserRoles(searchParams: SearchParams): AxiosPromise<Value> {
    var odfb = ODataFilterBuilder('and');
    // odfb.eq(CONST.OrganisationId, organisationId, false);
    let url = DefaultBackendHelper.makeUrl(
      `${URLS.gspUserRoleOdata}`,
      searchParams.dataOption,
      searchParams.orClauseFieldsIds,
      searchParams.filter,
      odfb,
      ['$expand=gspUserRoleDetails']
    );
    logger.log(`getGspUserRoles${url}`);
    return instance.get<Value>(url);
  },

  deleteGspUserRole(id: string): AxiosPromise {
    logger.debug('deleteGspUserRole');
    return instance.delete(`${URLS.gspUserRole}/${id}`);
  },
  updateGspUserRole(GspUserRole: GspUserRole): AxiosPromise<any> {
    console.log('updateGspUserRole GspUserRole :>> ', GspUserRole);
    logger.debug('updateGspUserRole');
    return instance.put<GspUserRole>(`${URLS.gspUserRole}/update`, gspUserRole.toAPI(GspUserRole));
  },
};
